var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "men_8"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#D98A90"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.374,115.394c-4.964-9.396-36.874-15.292-36.874-15.292s-31.911,5.896-36.875,15.292 C31.957,128.433,28.888,145,28.888,145H72.5h43.611C116.112,145,114.041,127.236,109.374,115.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.501,100.102c0,0,31.91,5.896,36.874,15.292c4.666,11.842,6.737,29.606,6.737,29.606H72.501 V100.102z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.814,
    y: 81.001,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.374,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.501,
    y: 81.001,
    style: {
      fill: "#E4B692"
    },
    width: 8.688,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.814,94.474c1.563,4.485,7.867,7.057,12.498,7.057 c1.677,0,3.306-0.281,4.876-0.795V81.001H63.814V94.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M109.374,115.394c-2.898-5.487-14.979-9.777-24.534-12.399 c-0.374,6.499-5.746,11.658-12.34,11.658c-6.593,0-11.965-5.159-12.339-11.658c-9.557,2.622-21.636,6.912-24.536,12.399 C31.957,128.433,28.888,145,28.888,145H72.5h43.611C116.112,145,114.041,127.236,109.374,115.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.837,62.652c0-18.162-10.001-28.489-22.337-28.489c-12.337,0-22.338,10.327-22.338,28.489 c0,7.609,2.329,24.456,6.301,27.889c2.73,2.424,11.637,6.576,15.991,6.576h0.002c0.015,0,0.029-0.002,0.046-0.002 c0.015,0,0.028,0.002,0.043,0.002h0.002c4.357,0,13.264-4.152,15.991-6.576C92.669,86.178,94.837,69.636,94.837,62.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.503,97.116c0.015,0,0.028,0.002,0.043,0.002h0.002c4.357,0,13.264-4.152,15.991-6.576 c4.13-4.364,6.299-20.905,6.299-27.889c0-18.162-10.001-28.489-22.337-28.489v62.952H72.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M91.439,75.247c-4.049-0.424-6.783-4.787-6.098-9.739c0.677-4.957,4.513-8.638,8.563-8.216 c4.047,0.422,6.777,4.783,6.094,9.739C99.319,71.988,95.488,75.665,91.439,75.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M45.162,67.031c-0.684-4.957,2.047-9.317,6.092-9.739c4.053-0.422,7.888,3.259,8.567,8.216 c0.684,4.953-2.053,9.315-6.1,9.739C49.672,75.665,45.841,71.988,45.162,67.031z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262421"
    },
    d: "M50.541,46.682c-2.182,4.591-1.903,11.531-1.903,11.531s2.661,0.734,3.569,4.067 c0-8.026,1.091-17.088,7.725-17.718c5.981-0.567,5.526,2.044,12.569,2.044c0-9.54,0-14.809,0-14.809 S57.613,31.797,50.541,46.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#262421"
    },
    d: "M94.46,46.682c-6.266-14.885-21.959-14.885-21.959-14.885s0,5.269,0,14.809 c7.042,0,6.587-2.611,12.568-2.044c6.634,0.63,7.723,9.692,7.723,17.718c0.91-3.333,3.559-4.158,3.559-4.158 S96.431,51.366,94.46,46.682z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#262421"
    },
    points: "72.503,81.001 72.503,83.74 64.791,85.032 64.791,84.005  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#262421"
    },
    points: "72.501,81.001 72.501,83.74 80.212,85.032 80.212,84.005  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E00315"
    },
    d: "M43.649,145h28.852h28.851v-36.042c-4.9-2.464-11.108-4.48-16.511-5.962 c-0.374,6.499-5.746,11.658-12.34,11.658c-6.593,0-11.965-5.159-12.339-11.658c-5.403,1.482-11.612,3.499-16.513,5.964 C43.649,108.96,43.649,145,43.649,145z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M55.19,136.889L49.42,145l-5.771-8.111l5.771-8.111L55.19,136.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M66.73,136.889L60.959,145l-5.77-8.111l5.77-8.111L66.73,136.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M78.27,136.889L72.501,145l-5.771-8.111l5.771-8.111L78.27,136.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M89.811,136.889L84.041,145l-5.771-8.111l5.771-8.111L89.811,136.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M101.351,136.889L95.581,145l-5.77-8.111l5.77-8.111L101.351,136.889z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M55.19,110.078l-5.77,8.11l-5.771-8.11l5.771-8.111L55.19,110.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M66.73,110.078l-5.771,8.11l-5.77-8.11l5.77-8.111L66.73,110.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M78.27,110.078l-5.769,8.11l-5.771-8.11l5.771-8.111L78.27,110.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M89.811,110.078l-5.77,8.11l-5.771-8.11l5.771-8.111L89.811,110.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M101.351,110.078l-5.77,8.11l-5.77-8.11l5.77-8.111L101.351,110.078z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M60.959,123.997l-5.77,8.111l-5.77-8.111l5.77-8.111L60.959,123.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M72.501,123.997l-5.771,8.111l-5.771-8.111l5.771-8.111L72.501,123.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M84.041,123.997l-5.771,8.111l-5.769-8.111l5.769-8.111L84.041,123.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C1E1C"
    },
    d: "M95.581,123.997l-5.77,8.111l-5.77-8.111l5.77-8.111L95.581,123.997z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C1E1C"
    },
    points: "95.581,123.997 101.351,132.108 101.351,115.886  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C1E1C"
    },
    points: "49.42,123.997 43.649,115.886 43.649,132.108  "
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M72.501,116.411c7.587,0,13.917-5.387,15.373-12.545c-1.56-0.464-3.091-0.894-4.541-1.277 c-0.532,5.516-5.178,9.828-10.832,9.828c-5.655,0-10.301-4.312-10.833-9.828c-1.45,0.383-2.981,0.813-4.541,1.277 C58.583,111.024,64.913,116.411,72.501,116.411z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.83c75bc70eb152f3543b8db8d79e9899.svg";
export { ForwardRef as ReactComponent };